import React from 'react';
import axios from "../../../containers/api";
import "./ManageUsers.css";
import {Badge, Button, CardBody, FormGroup, Input, Label, Table as TableStrap} from "reactstrap";
import {showCatchError, toEnglishNumbers} from "../../../helpers/Utils";

class EditUser extends React.Component {
    state = {
        Page: this.props && this.props.Page,
        agency: this.props && this.props.agency,
        memberAccessName: {
            access_Bill_List: "لیست اعلام بار",
            access_Bill_NumberRange: "لیست شماره بارنامه‌ها",
            access_Bill_Sent: "لیست بارنامه‌های صادر شده",
            access_Bill_Paid: "لیست بارنامه‌های پرداخت شده",
            access_Customer_Add: "افزودن مشتری",
            access_Customer_Delete: "حذف مشتری",
            access_Customer_List: "لیست مشتریان",
            access_Draft_Add: "افزودن حواله",
            access_Draft_Delete: "حذف حواله",
            access_Draft_List: "لیست حواله‌ها",
            access_Driver_Positions: "مدیریت رانندگان",
            access_Driver_Selected: "رانندگان انتخابی",
            access_Insurance_Management: "لیست بیمه",
            access_Insurance_Add: "افزودن بیمه",
            access_Insurance_Delete: "حذف بیمه",
            access_Insurance_Update: "ویرایش بیمه",
            access_Load_Manage: "لیست اعلام بار",
            access_Load_Add: "اعلام بار",
            access_Load_Delete: "حذف اعلام بار",
            access_Load_Update: "ویرایش اعلام بار",
            access_Member_List: "لیست کاربران",
            access_Member_Add: "افزودن کاربر",
            access_Member_Delete: "حذف کاربر",
            access_Member_Update: "ویرایش کاربر",
            access_ProductOwner_List: "لیست صاحبان کالا",
            access_ProductOwner_Add: "افزودن صاحب کالا",
            access_ProductOwner_Delete: "حذف صاحب کالا",
            access_ProductOwner_Update: "ویرایش صاحب کالا",
            access_Reserve_List: "لیست رزرو بار",
            access_Reserve_Add: "رزرو بار",
            access_Reserve_Delete: "لغو رزرو بار"
        }
    };

    postLoad = () => {
        this.props.closeSweetAlert();
        this.props.showSpinner();
        axios.post('api/ClientApi/Update', this.state.agency)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    this.props.showAlert("ویرایش کاربر جدید با موفقیت انجام شد!", "success");
                    this.props.closeModal("EditUserModal");
                } else {
                    this.props.showAlert("خطا در ویرایش کاربر", "error");
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    render() {
        return (
            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                <div className="d-flex flex-md-row flex-column justify-content-md-center flex-wrap">
                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>*نام کاربری</Label>
                        <Input value={this.state.agency.username} readOnly/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>نام و نام خانوادگی</Label>
                        <Input value={this.state.agency.fullname} maxLength={150}
                               onChange={(e) => this.setState({agency: {...this.state.agency, fullname: toEnglishNumbers(e.target.value)}})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>تلفن همراه</Label>
                        <Input value={this.state.agency.mobile} maxLength={11}
                               defaultValue={this.state.agency.mobile}
                               onChange={(e) => this.setState({agency: {...this.state.agency, mobile: toEnglishNumbers(e.target.value)}})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>کد ملی</Label>
                        <Input value={this.state.agency.nationalId} maxLength={50}
                               defaultValue={this.state.agency.nationalId}
                               onChange={(e) => this.setState({agency: {...this.state.agency, nationalId: toEnglishNumbers(e.target.value)}})}/>
                    </FormGroup>
                </div>

                {this.props.Page !== "Support" ?
                    <div className="w-md-50 w-100 add-user-table mt-4">
                        <TableStrap>
                            <thead>
                            <tr>
                                <th>نوع دسترسی</th>
                                <th>فعال/غیرفعال سازی</th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr>
                                {this.state.agency.access_Bill_List ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Bill_List} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Bill_List: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Bill_List} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Bill_List: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Bill_NumberRange ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Bill_NumberRange} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Bill_NumberRange: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Bill_NumberRange} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Bill_NumberRange: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Bill_Paid ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Bill_Paid} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Bill_Paid: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Bill_Paid} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Bill_Paid: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Bill_Sent ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Bill_Sent} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Bill_Sent: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Bill_Sent} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Bill_Sent: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Customer_Add ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Customer_Add} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Customer_Add: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Customer_Add} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Customer_Add: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Customer_Delete ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Customer_Delete} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Customer_Delete: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Customer_Delete} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Customer_Delete: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Customer_List ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Customer_List} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Customer_List: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Customer_List} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Customer_List: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Draft_Add ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Draft_Add} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Draft_Add: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Draft_Add} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Draft_Add: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Draft_Delete ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Draft_Delete} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Draft_Delete: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Draft_Delete} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Draft_Delete: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Draft_List ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Draft_List} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Draft_List: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Draft_List} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Draft_List: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Driver_Positions ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Driver_Positions} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Driver_Positions: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Driver_Positions} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Driver_Positions: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Driver_Selected ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Driver_Selected} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Driver_Selected: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Driver_Selected} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Driver_Selected: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Insurance_Management ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Insurance_Management} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Insurance_Management: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Insurance_Management} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Insurance_Management: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Insurance_Add ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Insurance_Add} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Insurance_Add: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Insurance_Add} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Insurance_Add: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Insurance_Delete ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Insurance_Delete} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Insurance_Delete: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Insurance_Delete} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Insurance_Delete: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Insurance_Update ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Insurance_Update} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Insurance_Update: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Insurance_Update} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Insurance_Update: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Load_Manage ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Load_Manage} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Load_Manage: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Load_Manage} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Load_Manage: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Load_Add ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Load_Add} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Load_Add: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Load_Add} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Load_Add: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Load_Delete ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Load_Delete} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Load_Delete: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Load_Delete} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Load_Delete: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Load_Update ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Load_Update} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Load_Update: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Load_Update} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Load_Update: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Member_List ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Member_List} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Member_List: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Member_List} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Member_List: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Member_Add ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Member_Add} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Member_Add: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Member_Add} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Member_Add: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Member_Delete ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Member_Delete} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Member_Delete: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Member_Delete} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Member_Delete: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Member_Update ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Member_Update} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Member_Update: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Member_Update} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Member_Update: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_ProductOwner_List ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_ProductOwner_List} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_ProductOwner_List: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_ProductOwner_List} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_ProductOwner_List: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_ProductOwner_Add ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_ProductOwner_Add} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_ProductOwner_Add: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_ProductOwner_Add} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_ProductOwner_Add: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_ProductOwner_Delete ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_ProductOwner_Delete} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_ProductOwner_Delete: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_ProductOwner_Delete} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_ProductOwner_Delete: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_ProductOwner_Update ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_ProductOwner_Update} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_ProductOwner_Update: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_ProductOwner_Update} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_ProductOwner_Update: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Reserve_List ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Reserve_List} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Reserve_List: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Reserve_List} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Reserve_List: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Reserve_Add ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Reserve_Add} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Reserve_Add: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Reserve_Add} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Reserve_Add: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>

                            <tr>
                                {this.state.agency.access_Reserve_Delete ?
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Reserve_Delete} {" "}
                                            <Badge color="success" pill>فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="danger" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Reserve_Delete: false}})}>
                                                غیرفعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                    :
                                    <>
                                        <td>
                                            {this.state.memberAccessName.access_Reserve_Delete} {" "}
                                            <Badge color="danger" pill>غیر فعال</Badge>
                                        </td>
                                        <td>
                                            <Button outline color="success" size="sm"
                                                    onClick={() => this.setState({agency: {...this.state.agency, access_Reserve_Delete: true}})}>
                                                فعال‌سازی
                                            </Button>
                                        </td>
                                    </>
                                }
                            </tr>
                            </tbody>

                        </TableStrap>
                    </div>
                    :
                    null
                }

                <div className="d-flex mt-2 justify-content-center">
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2" onClick={() => this.props.showSweetAlert("", "آیا از صحت اطلاعات وارد شده اطمینان دارید؟", "warning", this.postLoad)}>
                            ثبت
                        </Button>
                    </FormGroup>
                </div>
            </CardBody>
        )
    }
}

export default EditUser;